var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-item",class:{active: _vm.isActive}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.item.name))]),_c('span',{staticClass:"email"},[_vm._v(_vm._s(_vm.item.email))])])
}
var staticRenderFns = []

export { render, staticRenderFns }